// As Chips from Mui Material have an especific variant values
// It can not allow a generic variant enum because the component
// will throw an error if you try to pass a variant that is not
// allowed for default

export enum ChipVariants {
  Filled = 'filled',
  Outlined = 'outlined',
}
